export default "__VITE_ASSET__18cbb85c__"